module.exports = __webpack_public_path__ + "img/لوکس.59edb0a0.jpg";